import { render, staticRenderFns } from "./GongyiDetail.vue?vue&type=template&id=df2c7838&scoped=true&"
import script from "./GongyiDetail.vue?vue&type=script&lang=ts&"
export * from "./GongyiDetail.vue?vue&type=script&lang=ts&"
import style0 from "./GongyiDetail.vue?vue&type=style&index=0&id=df2c7838&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2c7838",
  null
  
)

export default component.exports